import type { SitePageEntity } from '@common/types/site-page.type';
import type { PagesState } from './pages.reducer';
import { WEBSITE_PAGES_FEATURE_KEY } from './pages.reducer';
import type { WebsiteState } from '../website-feature.reducer';

import { createSelector } from '@ngrx/store';
import { EContentSources } from '@common/enums';
import { websiteState } from '../website-state.selectors';
import { selectRouterParams } from '@web/store/router/router.selectors';

export const selectPagesState = createSelector(
    websiteState,
    (state: WebsiteState): PagesState => state[WEBSITE_PAGES_FEATURE_KEY]
);

export const selectPages = createSelector(
    selectPagesState,
    (state: PagesState): SitePageEntity[] => state?.pages || []
);
export const selectCurrentPage = createSelector(selectRouterParams, selectPages, ({ pageId }, pages) =>
    pages.find((p) => p.id.toString() === pageId?.toString())
);

export const selectIsPublishing = createSelector(selectPagesState, (state: PagesState): boolean => state?.publishing);
export const selectTotal = createSelector(selectPagesState, (state: PagesState): number => state?.total);
export const selectHasEduPages = createSelector(selectPages, (pages): boolean => {
    const eduContentSourceIds = [EContentSources.Education, EContentSources.WebEducation];
    return pages.some((p) => eduContentSourceIds.includes(p.content_source_id));
});

export const selectIsPersonalSite = createSelector(selectPages, (pages: SitePageEntity[]): boolean => {
    const contentSourceIds = [EContentSources.Website, EContentSources.MiniLanding];
    return pages.every((page) => contentSourceIds.includes(page.content_source_id));
});
